import { type CohortPath, type Metric, rowMeasurement } from './exploration'
import { percentage } from './model'

import type { AttributionFilters, AttributionSummary } from '@/api/attributionObservability'

export const meetingShare = (summary: AttributionSummary, parent?: AttributionSummary) =>
  parent ? percentage(summary.meeting_count, parent.meeting_count) : null

export const rowRateComparison = (
  summary: AttributionSummary,
  parent: AttributionSummary | undefined,
  metric: Metric,
  filters: AttributionFilters,
  parentFilters: AttributionFilters,
  path: CohortPath,
  parentLabel: string
) => {
  if (!parent) return null
  const child = rowMeasurement(summary, metric, filters, path)
  const previous = rowMeasurement(parent, metric, parentFilters, path.slice(0, -1))
  return child.identity === previous.identity && child.percent !== null && previous.percent !== null
    ? compareRates(child.percent, previous.percent, parentLabel)
    : null
}

const compareRates = (childRate: number, parentRate: number, parentLabel: string) => {
  const delta = Number((childRate - parentRate).toFixed(1))
  const amount = Math.abs(delta).toFixed(1)
  return {
    label: `${delta > 0 ? '+' : delta < 0 ? '−' : ''}${amount} pp`,
    parentRate,
    description: `${amount} percentage points ${delta > 0 ? 'above' : delta < 0 ? 'below' : 'from'} ${parentLabel} (${parentRate.toFixed(1)}%).`,
  }
}
